import React, { Fragment } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import Loader from 'components/Loader'
import PublicLayout from './Public'
import LoginLayout from './Login'
import MainLayout from './Main'

const Layouts = {
  public: PublicLayout,
  login: LoginLayout,
  main: MainLayout,
}

@withRouter
@connect(({ user }) => ({ user }))
class IndexLayout extends React.PureComponent {
  previousPath = ''

  componentDidUpdate(prevProps) {
    const { location } = this.props
    const { prevLocation } = prevProps

    if (location !== prevLocation) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const {
      children,
      location: { pathname, search },
      user,
    } = this.props

    const currentPath = pathname + search
    if (currentPath !== this.previousPath) {
      NProgress.start()
    }

    setTimeout(() => {
      NProgress.done()
      this.previousPath = currentPath
    }, 300)

    const getLayout = () => {
      if (pathname === '/') {
        return 'public'
      }
      if (/^\/user(?=\/|$)/i.test(pathname)) {
        return 'login'
      }
      return 'main'
    }

    const Container = Layouts[getLayout()]
    const isUserAuthorized = user.authorized
    const isUserLoading = user.loading
    const isLoginLayout = getLayout() === 'login'
    const isPasswordFlow = pathname === '/user/reset' || pathname === '/user/restore'

    const BootstrappedLayout = () => {
      if (isUserLoading && !isUserAuthorized && !isLoginLayout && !isPasswordFlow) {
        return <Loader />
      }

      if (!isLoginLayout && !isUserAuthorized && !isPasswordFlow) {
        return <Redirect to="/user/login" />
      }

      if (isLoginLayout && isUserAuthorized && !isPasswordFlow) {
        return <Redirect to="/main" />
      }

      return <Container>{children}</Container>
    }

    return <Fragment>{BootstrappedLayout()}</Fragment>
  }
}

export default IndexLayout
